module.exports = __webpack_public_path__ + "static/media/headerSecenodLogo.b9dc830f.svg";